import React from 'react'
import Star from '~/components/common/Star'

export const COMMENT_STATUS = {
  APPROVED: 'approved',
  SPAM: 'spam',
  PENDING: 'hold',
  TRASH: 'trash',
}

export const COMMENT_STATUS_OPTIONS = [
  {
    value: COMMENT_STATUS.APPROVED,
    label: 'Approved',
  },
  {
    value: COMMENT_STATUS.SPAM,
    label: 'Spam',
  },
  {
    value: COMMENT_STATUS.PENDING,
    label: 'Pending',
  },
]

export const COMMENT_STATUS_OPTIONS_2 = [
  {
    value: COMMENT_STATUS.PENDING,
    label: 'Under review',
  },
  {
    value: COMMENT_STATUS.APPROVED,
    label: 'Published',
  },
  {
    value: COMMENT_STATUS.SPAM,
    label: 'Spam',
  },
  {
    value: COMMENT_STATUS.TRASH,
    label: 'Trash',
  },
]

export const COMMENTLIST_STATUS_OPTIONS = [
  {
    value: COMMENT_STATUS.PENDING,
    label: 'Pending',
  },
  {
    value: COMMENT_STATUS.APPROVED,
    label: 'Approved',
  },
]

export const COMMENTS_TYPE = {
  ALL_COMMENTS: 'none-spam',
  SPAM: 'spam',
  TRASH: 'trash',
}

export const COMMENTS_RATING = [
  {
    value: 5,
    label: <Star value={5} readOnly />,
  },
  {
    value: 4,
    label: <Star value={4} readOnly />,
  },
  {
    value: 3,
    label: <Star value={3} readOnly />,
  },
  {
    value: 2,
    label: <Star value={2} readOnly />,
  },
  {
    value: 1,
    label: <Star value={1} readOnly />,
  },
]

export const COMMENTS_TAB = [
  {
    value: COMMENTS_TYPE.ALL_COMMENTS,
    label: 'All',
  },
  {
    value: COMMENTS_TYPE.SPAM,
    label: 'Spam',
  },
  {
    value: COMMENTS_TYPE.TRASH,
    label: 'Trash',
  },
]
